import { API, ApiService } from './api.service';
import { StudentKarte } from '@/models/student/student-karte';
import { StudentFindingsProposals } from '@/models/student/student-findings-proposals';
import { StudentTrends } from '@/models/student/student-trends';
import { RecommendationLetter, RecommendationLetterPolicies, GeneratedRecommendationLetter, GeneratedRecommendationLettersResponse } from '@/models/student/recommendation-letter';
import { GenerateRecommendationLetterRequest } from '@/models/student/generate-recommendation-letter-request';
import { RecommendationLetterUpdateRequest } from '@/models/student/recommendation-letter-update-request';

class StudentKarteService extends ApiService {
  constructor() {
    super();
  }

  getStudentKarte(studentID: number = 1): Promise<StudentKarte> {
    return this.get(StudentKarte, `students/${studentID}/karte`, {});
  }

  getStudentFindingsProposals(studentID: number = 1): Promise<StudentFindingsProposals> {
    return this.get(StudentFindingsProposals, `students/${studentID}/findingsProposals`, {});
  }

  getStudentTrends(studentID: number = 1): Promise<StudentTrends> {
    return this.get(StudentTrends, `students/${studentID}/trends`, {});
  }

  getStudentRecommendationLetters(studentID: number): Promise<RecommendationLetter[]> {
    return this.getList(RecommendationLetter, `students/${studentID}/recommendationLetters`, {});
  }

  getRecommendationLetter(studentID: number, id: number): Promise<RecommendationLetter> {
    return this.get(RecommendationLetter, `students/${studentID}/recommendationLetters/${id}`, {});
  }

  deleteRecommendationLetter(studentID: number, id: number): Promise<void> {
    return this.delete(`students/${studentID}/recommendationLetters/${id}`, {});
  }

  async generateRecommendationLetter(generateRecommendationLetterRequest: GenerateRecommendationLetterRequest): Promise<GeneratedRecommendationLettersResponse> {
    return this.post(GeneratedRecommendationLettersResponse, `students/${generateRecommendationLetterRequest.studentID}/recommendationLetters/generate`, generateRecommendationLetterRequest);
  }

  async generateRecommendationLetterPolicies(generateRecommendationLetterPoliciesRequest: GenerateRecommendationLetterRequest): Promise<RecommendationLetterPolicies> {
    return this.post(RecommendationLetterPolicies, `students/${generateRecommendationLetterPoliciesRequest.studentID}/recommendationLetters/policies`, generateRecommendationLetterPoliciesRequest);
  }

  updateRecommendationLetter(data: RecommendationLetterUpdateRequest): Promise<RecommendationLetter> {
    return this.put(RecommendationLetter, `students/${data.studentID}/recommendationLetters/${data.id}`, data);
  }
}

export const studentKarteService = new StudentKarteService();
